import type { PricingItem, ServiceContent, SocialLink, VideoItem } from '../types'

export const siteContent = {
  name: 'Kasia Staszewska',
  email: 'kasiastaszewskamusic@gmail.com',
  tagline: 'Śpiew, który tworzy emocje',
  intro:
    'Oprawa wokalna ślubu oraz lekcje śpiewu prowadzone z pasją, sercem i doświadczeniem.',
  formspreeEndpoint:
    import.meta.env.VITE_FORMSPREE_ENDPOINT || 'https://formspree.io/f/xqkjebpq',
  siteUrl: import.meta.env.VITE_SITE_URL || 'https://kasiastaszewska.pl',
  reviewsUrl: 'https://www.weselezklasa.pl/kasiastaszewska/#opinie',
  reviewsWidgetUrl: 'https://widgets.4wzk.pl/468/52468/type3.html',
}

export const services: ServiceContent[] = [
  {
    id: 'wedding',
    title: 'Oprawa wokalna ślubu',
    shortTitle: 'Oprawa ślubu',
    description:
      'Tworzę wyjątkową atmosferę w najważniejszych momentach Waszego dnia — z wyczuciem, spokojem i repertuarem dobranym do uroczystości.',
    href: '/oprawa-wokalna',
    cta: 'Poznaj ofertę ślubną',
  },
  {
    id: 'lessons',
    title: 'Lekcje śpiewu',
    shortTitle: 'Lekcje śpiewu',
    description:
      'Pomagam odkrywać i rozwijać Twój głos. Zajęcia dopasowuję do Ciebie — niezależnie od wieku, doświadczenia i poziomu zaawansowania.',
    href: '/lekcje-spiewu',
    cta: 'Zobacz lekcje',
  },
]

export const highlights = [
  {
    icon: 'heart' as const,
    title: 'Doświadczenie',
    text: 'Setki uroczystości, występów i godzin pracy z głosem.',
  },
  {
    icon: 'note' as const,
    title: 'Profesjonalizm',
    text: 'Przygotowanie muzyczne, sceniczne i indywidualny plan działania.',
  },
  {
    icon: 'star' as const,
    title: 'Indywidualne podejście',
    text: 'Każda historia, uroczystość i każdy głos są inne.',
  },
  {
    icon: 'microphone' as const,
    title: 'Pasja',
    text: 'Śpiew, który płynie prosto z serca i zostaje w pamięci.',
  },
]

export const socialLinks: SocialLink[] = [
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCZ8-WYbWtyVqps50EGxIbDQ/videos',
    platform: 'youtube',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/KasiaStaszewskaMusic',
    platform: 'facebook',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/kasiastaszewskamusic/',
    platform: 'instagram',
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@staszewskakasia',
    platform: 'tiktok',
  },
]

export const weddingVideos: VideoItem[] = [
  { id: 'MEHW9sIdzxM', title: 'Ty tylko mnie poprowadź' },
  { id: 'qXiasog38fA', title: 'Takie jest prawo miłości' },
  { id: 'mT6KgKMswTs', title: 'Schowaj mnie' },
  { id: 'uPaHxX0qEnc', title: 'Nim świt obudzi noc (Amazing Grace)' },
  { id: 'aZp_qFnNGAU', title: 'W cieniu Twoich rąk' },
  { id: 'xSk6gcB0xho', title: 'Niepojęty, niezmierzony' },
  { id: 'mm6Q4QQW800', title: 'Dzięki Ci Boże' },
  { id: 'WnWR9Hu5QF0', title: 'Nic nie musisz mówić, nic' },
  { id: '23ExbHFgoBI', title: 'Twoja miłość jak ciepły deszcz' },
  { id: 'E8-ilwbVHE8', title: 'Stoję dziś' },
  { id: 'PtY2D0395lQ', title: 'Hallelujah' },
]

export const churchRepertoire = [
  'Ave Maria',
  'Oceany',
  'Ty tylko mnie poprowadź',
  'Schowaj mnie',
  'Dzięki Ci Boże',
  'Jakie piękne jest imię Twe',
  'Panie, proszę przyjdź',
  'Takie jest prawo miłości',
  'Kiedy serca dwa',
  'Miłość Twa',
  'Ofiaruję Tobie, Panie mój',
  'Niepojęty, niezmierzony',
  'Wśród tylu dróg',
  'Stoję dziś',
  'Nic nie musisz mówić, nic',
  'Chwalę Ciebie, Panie',
  'Nim świt obudzi noc',
  'Twoja miłość jak ciepły deszcz',
  'Wielbić Pana chcę',
  'Gdy się łączą ręce dwie',
  'Gdy klęczę przed Tobą',
  'Jesteśmy piękni Twoim pięknem, Panie',
  'W cieniu Twoich rąk',
]

export const civilRepertoire = [
  'Perfect — Ed Sheeran',
  'Hallelujah — Leonard Cohen',
  'Shallow — Lady Gaga',
  'A Thousand Years — Christina Perri',
  'Imagine — John Lennon',
  'Ave Maria — F. Schubert',
  'Can You Feel the Love Tonight — Elton John',
  'All of Me — John Legend',
  'My Heart Will Go On — Celine Dion',
  'The Power of Love — Celine Dion',
  'One and Only — Adele',
]

export const lessonPrices: PricingItem[] = [
  {
    title: 'Lekcja śpiewu — 45 min',
    price: '120 zł',
    details: ['Dzieci, młodzież i dorośli', 'Lekcja online przez Zoom'],
  },
  {
    title: 'Pakiet 4 lekcji — 45 min',
    price: '440 zł',
    regularPrice: '480 zł',
    details: ['Zajęcia online przez Zoom', 'Do wykorzystania w ciągu 45 dni'],
  },
  {
    title: 'Lekcja śpiewu — 60 min',
    price: '160 zł',
    details: ['Dzieci, młodzież i dorośli', 'Lekcja online przez Zoom'],
  },
  {
    title: 'Pakiet 4 lekcji — 60 min',
    price: '560 zł',
    regularPrice: '640 zł',
    details: ['Zajęcia online przez Zoom', 'Do wykorzystania w ciągu 45 dni'],
    featured: true,
  },
]

export const lessonTestimonials = [
  { name: 'Marta', text: 'Z Kasią śpiewanie stało się dla mnie czymś, na co naprawdę czekam. ❤️ Każda lekcja daje mi mnóstwo radości, a przy okazji widzę, jak dużo się uczę i jak zmienia się mój głos. Kasia ma cudowne podejście, ogrom cierpliwości i taką energię, że nawet kiedy coś nie wychodzi, człowiek się nie poddaje. 🥹 Jestem naprawdę szczęśliwa, że trafiłam właśnie do niej. Polecam z całego serca! ❤️' },
  { name: 'Kamila', text: 'Pani Kasia to cudowna osoba. Nasza córcia uwielbia naukę śpiewu z Panią Kasią :) Pełne zaangażowanie i profesjonalizm :) Córcia uwielbia :) Polecamy w 100% i cieszymy się, że Pani Kasia uczy śpiewu naszą córeczkę :) Dziękujemy.' },
  { name: 'Kasia', text: 'Nauka śpiewu na najwyższym poziomie. Profesjonalizm i jeszcze raz profesjonalizm. Spotkania przygotowane zawsze na medal. Lekcje u Pani Kasi to nie tylko cenne wskazówki, ale również ćwiczenia podczas lekcji i przesyłane po zajęciach do samodzielnego trenowania. Zaplanowane zajęcia zawsze na czas, elastyczne podejście do czasu, którym dysponuje uczeń. Pani Kasia to cudowna, ciepła osoba, która swoim zaangażowaniem i podejściem stwarza niesamowitą atmosferę podczas zajęć, burzy mur tremy i wstydu i co najważniejsze potrafi motywować. Jako mama nastolatki, która mogła skorzystać z tych wszystkich lekcji, rad, ćwiczeń, wspólnej przygody, jaką jest śpiew — szczerze polecam!' },
  { name: 'Monika', text: 'Gorąco polecam zajęcia wokalne z Panią Kasią 👌 Bardzo profesjonalne i indywidualne podejście do pracy z uczniem, a oprócz tego niezwykle miła atmosfera podczas lekcji 🥰' },
]
